import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayoutContext } from '../../providers/LayoutProvider/Layout.context.ts';

const ThemeSelector = () => {
  const { setCurrentTheme, currentTheme } = useLayoutContext();
  const { t } = useTranslation('sidebar/sidebarComponent');

  const handleThemeChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setCurrentTheme(event.target.value);
  };

  return (
    <div className="w-full">
      <label className="block mb-2 text-sm font-bold">
        {t('page.themeSwitch.title')}
      </label>
      <select
        value={currentTheme}
        onChange={handleThemeChange}
        className="select select-bordered w-full max-w-xs"
      >
        <option value="leadsales">Leadsales (Light)</option>
        <option value="dark">Leadsales (Dark)</option>
      </select>
    </div>
  );
};

export default ThemeSelector;
